import { create } from "zustand";
import { PostDetailsPageActions } from "./PostDetailsModal";

export type PostDetailsActionType = {
    desiredAction: PostDetailsPageActions;
    commentId?: string;
};

type PostDetailsModalStoreType = {
    isPostDetailsModalOpen: boolean;
    postDetailsAction: PostDetailsActionType | undefined;
    selectedPostId: number | string | undefined;
    setIsPostDetailsModalOpen: (
        open: boolean,
        newPostid?: number | string,
    ) => void;
    setPostDetailsAction: (value: PostDetailsActionType | undefined) => void;
};

export const usePostDetailsModalStore = create<PostDetailsModalStoreType>()(
    (set) => ({
        isPostDetailsModalOpen: false,
        setIsPostDetailsModalOpen: (open, postId) => {
            set({
                isPostDetailsModalOpen: open,
                selectedPostId: postId,
            });
        },
        setPostDetailsAction: (
            newDesiredAction: PostDetailsActionType | undefined,
        ) => {
            set({
                postDetailsAction: newDesiredAction,
            });
        },
        selectedPostId: undefined,
        postDetailsAction: undefined,
    }),
);
